module.exports = {"header":"This page isn’t mobile-accessible","bodyWithCta":"We’re always working to improve the Trustpilot Business experience. Is mobile access to this page a priority for you?","bodyWithoutCta":"We’re always working to improve the Trustpilot Business experience, but this page hasn’t been optimised for mobile yet.","cta":"Make this a priority","ctaSuccess":"Request registered","goBack":"Go back"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/MobileFailover/localization/fr-FR/strings.json
// module id = 1116
// module chunks = 0